module.exports = __webpack_public_path__ + "portugal.svg?70a47eede02a7f19435d602e2294eb8b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/portugal.svg
// module id = 269
// module chunks = 10